import { isSuccess } from "@dgs/core";
import { useCallback } from "react";
import { filterService } from "../api/filter";
import { FilterSaveRequest, FilterableEntity, OnDemandFilterFormValues } from "./filterTypes";
import { useResetFilterQueries } from "./useResetFilterQueries";
import { mapFilterToRequest } from "./utils";

export const useCreateOnDemandFilter = (keysToInvalidate?: string[][]) => {
	const { resetFilterQueries } = useResetFilterQueries(keysToInvalidate);

	const createOnDemandFilter = useCallback(
		async (entity: FilterableEntity, filter: OnDemandFilterFormValues) => {
			const mappedFilter: FilterSaveRequest = mapFilterToRequest({
				...filter,
				type: "ON_DEMAND",
				entity: entity,
				name: "OnDemand filter",
			});

			const result = await filterService.store(mappedFilter);

			if (isSuccess(result)) {
				const id = result.data.data.id;
				resetFilterQueries(id);
			}

			return result;
		},
		[resetFilterQueries],
	);

	return {
		createOnDemandFilter,
	};
};
